import TooltipAtomTemplate from './templates/tooltip-atom';
import BaseAtomView from 'views/atoms/base-atom-view';
import TippyService from 'services/loader-handler-services/tippy-loader-service';
import LocaleService from 'services/loader-handler-services/locale-service';

const TooltipAtomView = BaseAtomView.extend({
  template: TooltipAtomTemplate,
  initialize: function () {
    BaseAtomView.prototype.initialize.apply(this, arguments);
  },
  render: function () {
    if (!this.model.get('parentView')) {
      console.warn('The tooltip atom requires a parentView to attach itself to');
      return;
    }
    const id = this.model.get('parentView')?.el?.children?.[0]?.id;
    if (id === '') {
      console.warn('The tooltip atom requires a parentView with an id.');
      return;
    }
    const placement = this.model.get('placement') || 'top';
    const config = {
      content: LocaleService.t(this.model.get('locale-key')),
      placement,
      theme: 'custom-theme',
    };
    TippyService.add(`#${id}`, config, false);
    BaseAtomView.prototype.render.apply(this, arguments);
  },
});

export default TooltipAtomView;
